<template>
  <div class="orders">
    <div class="columns is-gapless">
      <div id="split-1" class="column is-6" style="margin:0;padding:0">
        <filters
          :filters="filters"
          :width="20"
          @filter="onFilter"
          @reset="onFilterReset"
          :billingCode="code"
          :assetCode="asset"
          :managersId="managers"
          ref="filters"
        >
          <!-- <template #headerButtons>
            <button
              type="button"
              class="button is-light"
              @click.prevent="mode = 'list'"
            >
              <span class="icon"><i class="fa fa-list fa-lg"></i></span>
            </button>
          </template> -->
        </filters>
      </div>
      <div id="split-2" class="column is-6" style="margin:0;padding:0">
        <div class="columns is-gapless">
          <div id="split-2-1" class="column is-6" style="margin:0;padding:0">
            <orders-table
              :fetch-params="fetchParams"
              :selected.sync="selectedOrder"
              :checked.sync="checkedOrders"
              :source="orderSource"
              :per-page="perPage"
              :card-layout="splitSizes[0] <= 35"
              @fetch="onTableFetch"
              ref="ordersTable"
            >
              <template #headerButtons>
                <div class="mr-05" v-if="isFilterStatus('BLAP')">
                  <base-select
                    :service="$options.orderService"
                    fetch-func="listBillingCodes"
                    value-key="billing_code"
                    label-key="billing_code"
                    :disabled="checkedOrderIds.length == 0"
                  >
                    <template #control="{ value }">
                      <p class="control">
                        <b-button
                          :loading="billingCodeUpdating"
                          :disabled="checkedOrderIds.length == 0"
                          @click="updateBillingCode(value)"
                        >
                          UPDATE
                        </b-button>
                      </p>
                    </template>
                  </base-select>
                </div>
                <!-- <b-button
                  :loading="claiming"
                  :disabled="checkedOrderIds.length == 0"
                  @click="claim"
                  v-if="isFilterStatus('COMPLETED')"
                > -->
                <b-button
                  :loading="claiming"
                  @click="claim"
                  v-if="isFilterStatus('COMPLETED') && checkedOrderIds.length"
                >
                  CLAIM
                </b-button>
                <!-- <button :class="`button ${rejecting ? 'is-loading' : ''}`" @click="reject" v-if="isFilterStatusBLRQ && checkedOrderIds.length">
                  REJECT
                </button> -->
                <button
                  :class="`button ${approving ? 'is-loading' : ''}`"
                  @click="approve"
                  v-if="canBulkBlap"
                >
                  APPROVE
                </button>
                <b-button
                  :loading="exportLoading"
                  :disabled="exportLoading"
                  @click="onExport"
                >
                  EXPORT
                </b-button>
                <button
                  id="order-create"
                  class="button is-light"
                  @click="$router.replace({ name: 'order-create' })"
                  :disabled="!canIssueOrders"
                >
                  <span class="icon"
                    ><i class="fa fa-plus-square fa-lg"></i
                  ></span>
                </button>
                <!-- <b-button
                  id="orders_filter"
                  name="orders_filter"
                  :type="`${hasActiveFilters ? 'is-warning' : 'is-light'}`"
                  @click="mode = 'filter'"
                >
                  <span class="icon"><i class="fa fa-filter fa-lg"></i></span>
                </b-button> -->
                <b-field>
                  <b-radio-button
                    title="inbound"
                    v-model="orderSource"
                    native-value="inbound"
                    type="is-info"
                    ><span
                      class="icon"
                      title="ORDERS RECEIVED"
                      style="margin:0;"
                      ><i class="fa fa-inbox fa-lg"></i
                    ></span>
                  </b-radio-button>
                  <b-radio-button
                    title="outbound"
                    v-model="orderSource"
                    native-value="outbound"
                    type="is-info"
                    ><span class="icon" title="ORDERS ISSUED" style="margin:0;"
                      ><i class="fa fa-paper-plane fa-lg"></i
                    ></span>
                  </b-radio-button>
                </b-field>
              </template>
            </orders-table>
          </div>
          <div id="split-2-2" class="column is-6" style="margin:0;padding:0">
            <detail
              :order="selectedOrder"
              @close="unSelect"
              @fetched-relationships="onDetailFetchedRelationships"
              @cancel="onDetailCancel"
              @approve-billing="onDetailApproveBilling"
              v-if="selectedOrder"
            />
            <dashboard
              :filters="filters"
              :fetch-params="fetchParams"
              v-show="!selectedOrder"
              @filter="onDashboardFilter"
              @reset="onDashboardReset"
              ref="dashboard"
            >
              <template #headerButtons>
                <button class="button is-light">CREATE</button>
                <button class="button is-light">FILTER</button>
              </template>
            </dashboard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Split from "split.js";
import Filters from "@/components/OrderFilter/OrderFilterExperimental";
import OrdersTable from "../partials/table";
import Detail from "../partials/detail";
import Dashboard from "../partials/dashboard";
import BaseSelect from "@/components/partials/BaseSelect";
import { ordersListPageMixin } from "../mixins/ordersListPageMixin";

export default {
  components: {
    Filters,
    OrdersTable,
    Detail,
    Dashboard,
    BaseSelect
  },
  mixins: [ordersListPageMixin],
  data: () => ({
    splitSizes: [50, 50]
  }),
  mounted() {
    const initialSplit = Split(["#split-1", "#split-2"], {
      sizes: [20, 80]
    });
    initialSplit.destroy(true);

    let sizes = localStorage.getItem("__orders_page_split_sizes");
    sizes = sizes ? JSON.parse(sizes) : [50, 50];

    this.splitSizes = sizes;

    Split(["#split-2-1", "#split-2-2"], {
      sizes,
      gutterStyle: () => ({
        width: "5px",
        "background-color": "#222"
      }),
      onDragEnd: sizes => {
        localStorage.setItem(
          "__orders_page_split_sizes",
          JSON.stringify(sizes)
        );
        this.$refs.dashboard.loadChart();
        this.splitSizes = sizes;
      }
    });
  }
};
</script>

<style lang="scss">
.orders {
  @media only screen and (min-width: 769px) {
    .filters {
      .scrollable {
        height: calc(100vh - 7rem - 4rem);
      }
    }
    .order-table {
      .card-content {
        height: calc(100vh - 7rem);
      }
    }
    .detail {
      .scrollable {
        height: calc(100vh - 7rem);
      }
    }
    .dashboard {
      .scrollable {
        height: calc(100vh - 7rem);
      }
    }
  }
  /* Cursor is not showing initially */
  .gutter {
    cursor: col-resize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/layouts/experimental.vue